import React from 'react';
import { Box } from '@mui/material';
import { Header } from '../Header/Header';
import { Footer } from '../Footer/Footer';

interface LayoutProps {
  children: React.ReactNode;
  onNavigate?: (path: string) => void;
}

export const Layout: React.FC<LayoutProps> = ({ children, onNavigate }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header onNavigate={onNavigate} />
      
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          paddingTop: '76px', // Altura del header fijo
          backgroundColor: '#f5f5f5',
        }}
      >
        {children}
      </Box>
      
      <Footer />
    </Box>
  );
}; 